module.exports = __webpack_public_path__ + "media/images/qr-wx-50a4c0a1af99ff4721ca698d1ee2c924.png";